const normalizePath = (path) => {
  if (!path || path === '/') {
    return path || '/';
  }
  return path.replace(/\/+$/, '') || '/';
};

const isWorkspaceRoute = item => (
  item.workspaceTab !== false
  && typeof item.href === 'string'
  && item.href.startsWith('/')
  && !item.href.startsWith('/auth/')
  && !item.href.startsWith('/errors/')
);

export function getWorkspaceTabRoutes(items, isAdmin, inheritedNeedAdmin = false) {
  return items.flatMap((item) => {
    const needAdmin = inheritedNeedAdmin || Boolean(item.needAdmin);
    if (needAdmin && !isAdmin) {
      return [];
    }
    if (item.children?.length) {
      return getWorkspaceTabRoutes(item.children, isAdmin, needAdmin);
    }
    if (!isWorkspaceRoute(item)) {
      return [];
    }

    const href = normalizePath(item.href);
    return [{
      key: href,
      href,
      title: item.title,
    }];
  });
}

const pathMatchesScope = (pathname, scope) => (
  pathname === scope || pathname.startsWith(`${scope}/`)
);

export function resolveWorkspaceTab(pathname, routes) {
  const normalizedPath = normalizePath(pathname);
  return routes
    .filter(route => pathMatchesScope(normalizedPath, route.href))
    .sort((left, right) => right.href.length - left.href.length)[0] || null;
}

export function toWorkspaceUrl(location) {
  return `${location.pathname}${location.search || ''}${location.hash || ''}`;
}

function parseWorkspaceUrl(url) {
  if (typeof url !== 'string' || !url.startsWith('/') || url.startsWith('//')) {
    return null;
  }

  try {
    const parsed = new URL(url, 'https://workspace.invalid');
    if (parsed.origin !== 'https://workspace.invalid') {
      return null;
    }
    return {
      pathname: parsed.pathname,
      url: `${parsed.pathname}${parsed.search}${parsed.hash}`,
    };
  } catch (_error) {
    return null;
  }
}

export function isWorkspaceUrlForTab(key, url, routes) {
  const parsed = parseWorkspaceUrl(url);
  return Boolean(parsed && resolveWorkspaceTab(parsed.pathname, routes)?.key === key);
}

export function getWorkspaceTabUrl(key, url, routes) {
  const parsed = parseWorkspaceUrl(url);
  if (parsed && resolveWorkspaceTab(parsed.pathname, routes)?.key === key) {
    return parsed.url;
  }
  return routes.find(route => route.key === key)?.href || '/groups';
}
